import { render, staticRenderFns } from "./column3.vue?vue&type=template&id=8fe6ee9e&scoped=true&"
import script from "./column3.vue?vue&type=script&lang=js&"
export * from "./column3.vue?vue&type=script&lang=js&"
import style0 from "./column3.vue?vue&type=style&index=0&id=8fe6ee9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe6ee9e",
  null
  
)

export default component.exports